.searchDropdown {
  :global(.input-group-text) {
    height: 62px;
    border-radius: 0;
    border-right: 0;
    &::after {
      display: none;
    }
  }
}
